import axios from 'axios';
import { API_URL } from '../../../support/api';
import { PaginatedValue } from '../../../support/utils';
import { IRelease } from '../models/Release';

export const BASE_RELEASE_URL = `${API_URL}/v1/management/module-management/releases`;
export const GET_ALL_RELEASE_URL = `${API_URL}/v1/management/module-management/releases/get-all`;
export const CREATE_RELEASE_URL = `${API_URL}/v1/management/module-management/releases/create`;

export const listRelease = async (search = '', direction = 'asc') => {
  const URL = `${BASE_RELEASE_URL}/list?search=${search}&direction=${direction}`;
  const {
    data: { value },
  } = await axios.get<{ value: PaginatedValue<IRelease> }>(URL);

  return value;
};

export const createRelease = async (payload: IRelease) => {
  const {
    data: { value },
  } = await axios.post<{ value: IRelease }>(CREATE_RELEASE_URL, payload);

  return value;
};

export const viewRelease = async (id: number | string) => {
  const {
    data: { value },
  } = await axios.get<{ value: IRelease }>(`${BASE_RELEASE_URL}/${id}/get`);

  return value;
};

export const updateRelease = async (payload: IRelease) => {
  const {
    data: { value },
  } = await axios.post<{ value: IRelease }>(
    `${BASE_RELEASE_URL}/${payload.id}/update`,
    payload
  );

  return value;
};

export const deleteRelease = async (payload: IRelease) => {
  const {
    data: { value },
  } = await axios.post<{ value: IRelease }>(
    `${BASE_RELEASE_URL}/${payload.id}/delete`,
    payload
  );

  return value;
};

// unpaginated categories
export const getAllRelease = async () => {
  const {
    data: { value },
  } = await axios.get<{ value: Array<IRelease> }>(GET_ALL_RELEASE_URL);

  return value;
};
